import { twMerge } from 'tailwind-merge';

interface MediaNotFoundProps {
  icon?: React.ReactNode;
  notFoundText?: string;
  containerClassName?: string;
  defaultIconClassName?: string;
}

export const MediaNotFound = ({
  icon,
  notFoundText,
  containerClassName,
  defaultIconClassName,
}: MediaNotFoundProps) => {
  const renderErrorElement = (text: string) => {
    return (
      <div className="flex justify-center gap-1.5 max-w-full">
        <i className="-mt-1.25 ki-outline ki-information-1 text-purple-400 text-xl shrink-0" />
        <div className="text-white font-medium">{text}</div>
      </div>
    );
  };

  return (
    <div
      className={twMerge(
        'absolute inset-0 w-full h-full bg-blue-131025',
        containerClassName,
      )}
    >
      <div className="h-full flex flex-col justify-center items-center px-4">
        {icon || (
          <i
            className={twMerge(
              'ki-outline ki-picture text-white text-[70px]',
              defaultIconClassName,
            )}
          />
        )}
        {notFoundText && (
          <div className="mt-3 max-w-full">
            {renderErrorElement(notFoundText)}
          </div>
        )}
      </div>
    </div>
  );
};
